module.exports = __webpack_public_path__ + "assets/uikit.cabb5bf9.svg";